<template>
	<div class="row cl-bc">
		<div class="col-xs-12 cl-bc-description">
			<!-- @slot text element with formated widget description -->
			<slot name="chart-description" />
		</div>

		<div class="col-xs-12 cl-bc-legend">
			<horizontal-legend :data="widgetData.legend">
				<template #Iball_primaryIndex>
					<slot name="Iball_primaryIndex"/>
				</template>
				<template #superscript1>
					<slot name="superscript1" />
				</template>
			</horizontal-legend>
		</div>

		<div class="col-xs-12 cl-bc-chart-container">
			<img v-if="widgetData.image" :src="widgetData.image" >
			<p v-else>There is no data chart available yet</p>
		</div>

		<div class="col-xs-12 cl-bc-adjustdate">
			<!-- @slot text element with formated adjust date -->
			<slot name="adjust-date" />
		</div>
	</div>
</template>

<script>
import HorizontalLegend from './HorizontalLegend';

export default {
	name: 'HorizontalChart',
	components: { HorizontalLegend },
	props: {
		/**
		 * widget data object with:
		 *
		 * image: String (base 64 image string)
		 * legend: [{ text, color, shape, slot }]
		 */
		widgetData: {
			type: Object,
			default: () => ({})
		}
	}
};
</script>

<style scoped>
.cl-bc {
	color: #333;
	font-family: 'AvenirNextLTW01-Regular', Arial;
}
.cl-bc-title {
	display: inline-block;
	font-size: 18px;
	font-weight: 500;
	margin: 13px 0 20px;
	font-family: 'Avenir Next LT W01 Demi', Arial;
}
.cl-bc-viwer {
	font-size: 13px;
	font-weight: 500;
	margin: 13px 0 20px;
	font-family: 'Avenir Next LT W01 Demi', Arial;
}
.cl-bc-adjustdate {
	margin-top: 13px;
	font-size: 12px;
	font-family: 'AvenirNextLTW01-Condens\ 721299', Arial;
	color: #666;
}
.cl-bc-disclosure-link {
	padding-bottom: 20px;
}
.cl-bc-disclosure-link > a {
	color: #1d5799;
	text-decoration: none;
	font-family: 'Avenir', Arial;
	font-size: 14px;
	font-weight: 700;
}
.cl-bc-chart-container > img {
	width: 100%;
}
</style>
